<template>
  <div class="wrap">
    <div class="bannerimg relative">
      <img src="@/assets/image/lunbo/lunbo2.png" alt="" class="w-full" />
      <div
        class="biaotowenzi absolute top-1/2 left-1/4 -translate-y-1/2 text-white text-left p-5 z-2"
      >
        <h2 class="text-6xl font-bold leading-[101.36px]">
          信息与通信方案服务提供商
        </h2>
        <br /><br /><br />
        <p class="text-lg font-bold leading-10">诚信、务实、创新、进取</p>
      </div>
    </div>
    <div class="news-detail-bg">
      <div class="news-detail-main">
        <div class="news-detail-title">{{ currentArticle.title }}</div>
        <div class="news-detail-meta">
          <span
            ><router-link
              to="/workspace#news"
              style="color: #888; text-decoration: none"
              >公司动态</router-link
            ></span
          >
          <span class="meta-date">{{ currentArticle.date }}</span>
        </div>
        <div class="news-detail-img-wrap">
          <img
            :src="require('@/assets/gsdt/gsdt.jpg')"
            class="news-detail-img"
          />
        </div>
        <div class="news-detail-content">
          {{ currentArticle.content }}
        </div>
        <div class="news-detail-nav">
          <div class="news-detail-prev">
            上一篇：
            <span v-if="prevArticle">
              <router-link
                :to="prevArticle.link"
                style="color: #f44336; text-decoration: underline"
                >{{ prevArticle.title }}</router-link
              >
            </span>
            <span v-else>暂无</span>
          </div>
          <div class="news-detail-next">
            下一篇：
            <span v-if="nextArticle">
              <router-link
                :to="nextArticle.link"
                style="color: #f44336; text-decoration: underline"
                >{{ nextArticle.title }}</router-link
              >
            </span>
            <span v-else>暂无</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PenghaiDDI",
  data() {
    return {
      articles: [
        {
          id: 1,
          title: "澎海科技成功举办HCIE认证培训",
          date: "2024年03月15日",
          content:
            "澎海科技近日成功举办了华为HCIE认证培训课程，吸引了众多IT专业人士参与。此次培训旨在提升学员的网络技术能力，助力职业发展。",
          link: "/news/1",
        },
        {
          id: 2,
          title: "澎海科技推出新一代DDI解决方案",
          date: "2024年03月10日",
          content:
            "澎海科技发布了新一代DDI（DNS、DHCP、IPAM）解决方案，为企业网络管理提供更高效、更安全的服务。",
          link: "/news/2",
        },
        {
          id: 3,
          title: "澎海科技与金融机构达成战略合作",
          date: "2024年03月05日",
          content:
            "澎海科技与多家金融机构达成战略合作，共同推进金融科技领域的创新与发展。",
          link: "/news/3",
        },
        {
          id: 4,
          title: "澎海科技云服务升级完成",
          date: "2024年02月28日",
          content:
            "澎海科技宣布完成云服务平台的全面升级，为用户提供更稳定、更高效的云服务体验。",
          link: "/news/4",
        },
        {
          id: 5,
          title: "澎海科技江西市场取得重大突破",
          date: "2024年02月20日",
          content:
            "澎海科技在江西市场取得重大突破，成功签约多个重要项目，进一步扩大市场份额。",
          link: "/news/5",
        },
      ],
      currentArticleId: 2,
    };
  },
  computed: {
    currentArticle() {
      return (
        this.articles.find((article) => article.id === this.currentArticleId) ||
        this.articles[1]
      );
    },
    prevArticle() {
      const prevId = this.currentArticleId - 1;
      return this.articles.find((article) => article.id === prevId);
    },
    nextArticle() {
      const nextId = this.currentArticleId + 1;
      return this.articles.find((article) => article.id === nextId);
    },
  },
};
</script>

<style scoped>
.wrap {
  width: 100%;
}

.bannerimg {
  position: relative;
}

.bannerimg .biaotowenzi {
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-50%);
  color: white;
  text-align: left;
  max-width: 80%;
  padding: 20px;
  z-index: 2;
}

.bannerimg .biaotowenzi h2 {
  font-size: 70px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 101.36px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
}

.bannerimg .biaotowenzi p {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 30px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
}

.news-detail-bg {
  background: #fff;
  min-height: 100vh;
  padding: 20px 0;
  width: 100%;
}

.news-detail-main {
  max-width: 1440px;
  margin: 0 auto;
  background: #fff;
  padding: 40px 20px;
  box-sizing: border-box;
}

.news-detail-title {
  font-size: 44px;
  font-weight: 700;
  color: #222;
  margin-bottom: 22px;
  text-align: left;
  line-height: 1.3;
  letter-spacing: 0px;
}

.news-detail-meta {
  color: #888;
  font-size: 14px;
  margin-bottom: 28px;
  text-align: left;
}

.news-detail-meta .meta-date {
  margin-left: 22px;
}

.news-detail-img-wrap {
  margin-bottom: 32px;
  text-align: left;
}

.news-detail-img {
  max-width: 100%;
  width: auto;
  height: auto;
  border-radius: 0;
  display: block;
}

.news-detail-content {
  font-size: 19px;
  color: #333;
  margin-bottom: 48px;
  text-align: left;
  line-height: 1.8;
}

.news-detail-nav {
  display: flex;
  justify-content: flex-start;
  gap: 40px;
  font-size: 16px;
  color: #222;
  margin-top: 18px;
}

.news-detail-nav a {
  color: #f44336;
  text-decoration: none;
  font-weight: 500;
}

.news-detail-nav a:hover {
  text-decoration: underline;
}

.news-detail-prev,
.news-detail-next {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/view/Match/PenghaiDDI.vue